import { Box } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import { Menu } from 'Components/RoadmapComponents/Menu';
import { useState } from 'react';
import userIcon from '../../assets/images/userIcon.png';
import pianoIcon from '../../assets/images/pianoIcon.png';
import cardIcon from '../../assets/images/cardIcon.png';
import selectedUserIcon from '../../assets/images/selectedUserIcon.png';
import selectedPianoIcon from '../../assets/images/selectedPianoIcon.png';
import selectedCardIcon from '../../assets/images/selectedCardIcon.png';
import accessibilitySelected from 'assets/images/accessibility-selected.png';
import accessibilityUnselected from 'assets/images/accessibility-unselected.png';

import Account from './Account';
import Keyboard from './Keyboard';
import Notifications from './Notifications';
import Billing from './Billing';
import Accessibility from './Accessibility';
import ExperimentalFeatures from 'Containers/ExperimentalFeatures/ExperimentalFeatures';

enum PageSelectEum {
  account = 'account',
  keyboard = 'keyboard',
  billing = 'billing',
  accessibility = 'accessibility',
  notifications = 'notifications',
  experimentalFeatures = 'experimentalFeatures',
}

type PageSelectionProps = {
  selected: boolean;
  onClick: () => void;
  selectedIcon: string | React.ReactNode;
  unselectedIcon: string | React.ReactNode;
  title: string;
};

const PageSelection = ({
  selected,
  onClick,
  selectedIcon,
  unselectedIcon,
  title,
}: PageSelectionProps) => {
  return (
    <Box
      sx={
        selected
          ? { ...selectContainerStyles, ...selectSelectedContainerStyles }
          : { ...selectContainerStyles }
      }
    >
      <Box
        sx={selected ? { ...selectStyles, ...selectSelectedStyles } : { ...selectStyles }}
        onClick={onClick}
      >
        <Box sx={imgContainerStyles}>
          {selected ? (
            typeof selectedIcon === 'string' ? (
              <img style={{ height: '100%' }} src={selectedIcon} alt="" />
            ) : (
              selectedIcon
            )
          ) : typeof unselectedIcon === 'string' ? (
            <img style={{ height: '100%' }} src={unselectedIcon} alt="" />
          ) : (
            unselectedIcon
          )}
        </Box>
        <Box sx={textStyles}>{title}</Box>
      </Box>
    </Box>
  );
};

const SettingsPage = () => {
  const [subSelect, setSubSelect] = useState(PageSelectEum.account);

  return (
    <Box //className="foo"
      sx={containerStyles}
    >
      <Menu selected={'Settings'} />
      <Box
        sx={{
          width: 'calc(100% - var(--app-sidebar-width, 100px))',
          height: '100%',
          // background: 'linear-gradient(0deg, black, #1D2F44)'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: '40px',
          }}
        >
          <Box sx={titleContainerStyles}>
            <Box sx={titleStyles}>Settings</Box>
          </Box>
          <Box sx={{ display: 'flex', marginLeft: '50px' }}>
            <PageSelection
              title="Account"
              selectedIcon={selectedUserIcon}
              unselectedIcon={userIcon}
              onClick={() => setSubSelect(PageSelectEum.account)}
              selected={subSelect == PageSelectEum.account}
            />
            <PageSelection
              title="Keyboard"
              selectedIcon={selectedPianoIcon}
              unselectedIcon={pianoIcon}
              onClick={() => setSubSelect(PageSelectEum.keyboard)}
              selected={subSelect == PageSelectEum.keyboard}
            />
            {/* <PageSelection
              title="Notifications"
              selectedIcon={selectedNotificationIcon}
              unselectedIcon={notificationIcon}
              onClick={() => setSubSelect(PageSelectEum.notifications)}
              selected={(subSelect==PageSelectEum.notifications)}
            /> */}
            <PageSelection
              title="Billing"
              selectedIcon={selectedCardIcon}
              unselectedIcon={cardIcon}
              onClick={() => setSubSelect(PageSelectEum.billing)}
              selected={subSelect == PageSelectEum.billing}
            />
            <PageSelection
              title="Accessibility"
              selectedIcon={accessibilitySelected}
              unselectedIcon={accessibilityUnselected}
              onClick={() => setSubSelect(PageSelectEum.accessibility)}
              selected={subSelect == PageSelectEum.accessibility}
            />
            {process.env.REACT_APP_NODE_ENV !== 'prd' && (
              <PageSelection
                title="Experimental Features"
                selectedIcon={<ScienceIcon sx={{ color: '#469F6A', fontSize: 18 }} />}
                unselectedIcon={<ScienceIcon sx={{ color: '#FFFFFF', fontSize: 18 }} />}
                onClick={() => setSubSelect(PageSelectEum.experimentalFeatures)}
                selected={subSelect == PageSelectEum.experimentalFeatures}
              />
            )}
          </Box>

          {subSelect == PageSelectEum.account && <Account />}
          {subSelect == PageSelectEum.keyboard && <Keyboard />}
          {subSelect == PageSelectEum.notifications && <Notifications />}
          {subSelect == PageSelectEum.billing && (
            <>
              <Billing />
            </>
          )}
          {subSelect == PageSelectEum.accessibility && <Accessibility />}
          {process.env.REACT_APP_NODE_ENV !== 'prd' &&
            subSelect == PageSelectEum.experimentalFeatures && <ExperimentalFeatures />}
        </Box>
      </Box>
    </Box>
  );
};
export default SettingsPage;

const selectStyles = {
  color: 'white',
  margin: '5px 5px 5px 5px',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    background: 'rgb(202,124,98,.25)',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: '0.3s',
    boxShadow: '0px 0px 5px 5px rgb(202,124,98,.25)',
  },
};

const imgContainerStyles = {
  marginRight: '10px',
  height: '18px',
};

const textStyles = {
  //fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '14px',
  lineHeight: '24px',
  letterSpacing: '1px',
  textTransform: 'uppercase',
  color: '#FFFFFF',
};

const selectContainerStyles = {
  marginRight: '20px',
};
const selectSelectedContainerStyles = {
  borderBottom: '2px solid',
  borderColor: '#469F6A',
};
const selectSelectedStyles = {
  borderBottomColor: '#469F6A',
  borderBottomWidth: 10,
  color: '#469F6A',
};

const containerStyles = {
  display: 'flex',
  height: '100%',
  width: '100%',
  background: 'linear-gradient(0deg, black, #1D2F44)',
};

const titleContainerStyles = {
  width: '100%',
  height: '100px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '20px',
};
const titleStyles = {
  marginLeft: '50px',
  fontStyle: 'normal',
  fontWeight: '300',
  fontSize: '48px',
  lineHeight: '58px',
  letterSpacing: '0.01em',
  color: '#FFFFFF',
};
